
import barba from '@barba/core';
import Swiper from 'swiper';
import Splide from "@splidejs/splide";
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default class{

	constructor(){

        barba.hooks.beforeOnce((data) => {
            // this.heroSlider()
            // this.businessSlider()
            this.contactSlider()
            //this.interviewSlider()
            this.interviewSliderSplide()
        })
        barba.hooks.afterEnter((data) => {
            // this.heroSlider()
            this.businessSlider()
            this.contactSlider()
            //this.interviewSlider()
            this.interviewSliderSplide()
        });
        
    }

    interviewSliderSplide() {
        const campusSlider = document.getElementById('js-interview__slider');
        if(campusSlider){
            const target = '#js-interview__slider.splide';
            const target_options = {
                type   : 'loop',
                //arrowPath: 'M29.75,9.3948,21.5281,1.1735a.8479.8479,0,0,0-.601-.261L20.9124.9119a.8526.8526,0,0,0-.5956.2409.8642.8642,0,0,0-.0027,1.23l6.7618,6.7611H.7316a.8566.8566,0,1,0,0,1.7131H27.0759l-6.7591,6.7591a.8576.8576,0,0,0-.0214,1.2113.8462.8462,0,0,0,.61.2583.8949.8949,0,0,0,.621-.2556l8.2233-8.224A.8587.8587,0,0,0,29.75,9.3948Z',
                arrows: false,
                pagination: false,
                drag: false,
                gap: 20,
                autoWidth: true,
                autoScroll: {
                    speed: 0.5,
                    pauseOnHover: false,
                },
                breakpoints : {
                    767: {
                        autoScroll: {
                            speed: 0.4
                        },
                    },
                }
            };
            
            const mySplide = new Splide(target, target_options);
            mySplide.mount({ AutoScroll });
        }
    }
    
    businessSlider() {
        new Swiper ('#js-business__slider', {
            speed: 4000,
            slidesPerView: 3.5,
            spaceBetween: 20,
            loop: true,
            // スワイプ操作をできないようにする
            allowTouchMove: false,
            autoplay: {
                // 0にすることで流れ続けるようになる
                delay: 0,
                disableOnInteraction: false,
            },
            breakpoints: {
                1400: {
                    slidesPerView: 4,
                },
                1100: {
                    slidesPerView: 3.5,
                },
                992: {
                    slidesPerView: 3,
                    speed: 6000,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 10,
                },
                576: {
                    slidesPerView: 3.5,
                },
                320: {
                    slidesPerView: 2.5,
                }
            }
        })
    }
    interviewSlider() {
        new Swiper ('#js-interview__slider', {
            speed: 3600,
            slidesPerView: 1.5,
            spaceBetween: 20,
            loop: true,
            // スワイプ操作をできないようにする
            allowTouchMove: false,
            autoplay: {
                // 0にすることで流れ続けるようになる
                delay: 0,
                disableOnInteraction: false,
            },
            breakpoints: {
                992: {
                    slidesPerView: 4,
                    spaceBetween: 20,
                },
                768: {
                    slidesPerView: 3.5,
                },
                576: {
                    slidesPerView: 2.5
                }
            }
        })
    }
    contactSlider(){
        new Swiper ('.p-contact__slider',{
            loop: true,
            speed:1000,
            autoplay: {
                delay: 4000
            }
        })
    }
}